import styled from 'styled-components';
import { Caption } from '@routific/hive';

export const HeaderTextStack = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
`;

export const HeaderEllipsisCaption = styled(Caption)`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
